import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { RaciService } from '../../../modules/raci/services/raci.service';
import { ProjectValuationTabs } from '../../enum';
import { NavigationActionBase } from '../../navigation-action-base';
import { NavigationService } from '../../navigation.service';
import { RaciNavigationService } from '../../raci-navigation.service';
import { EventBusService } from '../../../services/event-bus.service';
import { AppStorageService } from '../../../services/app-storage.service';
/**
 * Project navigation component
 */
@Component({
  selector: 'project-navigation',
  templateUrl: './project-navigation.component.html',
  styles: []
})
export class ProjectNavigationComponent extends NavigationActionBase implements OnInit {
  /**
   * Search tab visibility
   */
  @Input() searchTabVisible: boolean;
  /**
   * Change detector reference
   */
  _ref: ChangeDetectorRef;
  /**
   * Navigation service
   */
  _navigationService: NavigationService;
  /**
   * Raci navigation service
   */
  _raciNavigationService: RaciNavigationService;
  /**
   * Raci service
   */
  _raciService: RaciService
  /**
   * Infobar visibility
   */
  infobarVisible = false;
  /**
   * Active infobar
   */
  activeInfobar = '';
  /**
   * Selected tab
   */
  selectedTab: ProjectValuationTabs = ProjectValuationTabs.Projects;
  /**
   * Search mode
   */
  searchMode = 'projectstd';
  /**
   * Disable currencies action
   */
  disableCurrenciesAction = false;
  /**
   * Show paricipants assignment navigation
   */
  showParicipantsAssignmentNavigation = false;
  /**
   * Show steps
   */
  showSteps = false;
  /**
   * Is participants icon enabled
   */
  isParticipantsIconEnabled = false;
  /**
   * Hide participants icon
   */
  hideParticipantsIcon = true;
  /**
   * Disable cancel
   */
  disableCancel = false;
  /**
   * Close participant assignment
   */
  closeParticipantAssignment = false;

  /**
   * Constructor
   * @param appStorage
   * @param eventBus
   * @param ref
   * @param navigationService
   * @param raciNavigationService
   * @param raciService
   */
  constructor(appStorage: AppStorageService, eventBus: EventBusService, ref: ChangeDetectorRef, navigationService: NavigationService, raciNavigationService: RaciNavigationService, raciService: RaciService) {
    super(appStorage, eventBus, ref, navigationService);
    this._ref = ref;
    this._navigationService = navigationService;
    this._raciNavigationService = raciNavigationService;
    this._raciService = raciService;
  }
  /**
   * Initializes the component
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.hideParticipantsIcon = this.appStorage.getSelectedProject() === null;
    this.subscribeToActiveTab();
    this.isParticipantsIconEnabled = this.isProjectSelected();
    this.onEvents.push(this.eventBus.subscribeEvent('PVInfobarVisibilityChanged', (visible) => {
      setTimeout(() => {
        this.infobarVisible = visible;
        this.ref.markForCheck();
      });
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('hideParticipantsIcon', (visible) => {
      setTimeout(() => {
        this.hideParticipantsIcon = (visible === null) ? !this.isProjectSelected() : visible;// allow for project selection to influence hide status
        this.ref.markForCheck();
      });
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('disableCancel', (data) => {
      setTimeout(() => {
        this.disableCancel = data;
        this.ref.markForCheck();
      });
    }));

    this.onEvents.push(
      this.eventBus.subscribeEvent('appStorage:setSelectedProject', (selectedProject) => {
        setTimeout(() => {
          this.disableCurrenciesAction = (selectedProject === null);
          this.ref.markForCheck();
          if (selectedProject) {
            this.showSteps = selectedProject.HasParticipants && selectedProject.HasProperties;
            this.isParticipantsIconEnabled = true;
            this.hideParticipantsIcon = false;
          } else {
            this.showSteps = false;
            this.isParticipantsIconEnabled = false;
            this.hideParticipantsIcon = true;
          }
        });
      })
    );

    this._raciNavigationService._closeParticipantsAssignment.subscribe(data => {
      if (this.closeParticipantAssignment) {
        if (data) {
          this.eventBus.broadcastEvent("openConfirmDialog", {
            success: () => {
              this.showParicipantsTemplate();
              this.closeParticipantAssignment = false;
              this.ref.markForCheck();
            },
            cancel: () => {
              //Nothing
            },
          }, 'closeParticipantAssignment');
        } else {
          this.showParicipantsTemplate();
          this.closeParticipantAssignment = false;
        }
      }
    });

    this.ref.markForCheck();
  }
  /**
   * Trigger action
   * @param action
   * @param keepInfobarOpen
   */
  triggerAction(action: string, keepInfobarOpen = false) {
    //disable on "new project" action, will be reset in 'appStorage:setSelectedProject' event
    this.disableCurrenciesAction = (action === 'newProjectDataFromNav') || this.disableCurrenciesAction;
    this.ref.markForCheck();

    super.triggerAction(action, keepInfobarOpen);
  }
  /**
   * Subscribe to active tab
   */
  subscribeToActiveTab() {
    this.subscriptions.add(this._navigationService.activeProjectValuationTab$.subscribe(tab => {
      this.selectedTab = tab;
      if (this.searchTabVisible) {
        this.searchTabVisible = !this.searchTabVisible;
      }
      this._ref.markForCheck();
    }))
  }
  /**
   * Can add new currency
   */
  get canAddNewCurrency() {
    return this.infobarVisible && this.activeInfobar === 'currencies';
  }
  /**
   * Info bar visibility clicked
   */
  infoBarVisibilityClicked() {
    this.activeInfobar = 'pictures';
    this.toggleActiveInfobar();
  }
  /**
   * Currencies editing clicked
   */
  currenciesEditingClicked() {
    this.activeInfobar = 'currencies';
    this.toggleActiveInfobar();
  }
  /**
   * Toggle active info bar
   */
  toggleActiveInfobar() {
    this.eventBus.broadcastEvent(`buttonTogglePVInfoModeClicked`, { infobarType: this.activeInfobar });
  }
  /**
   * Assign calculation model template
   */
  assignCalculationModelTemplate() {
    const selectedProject = this.appStorage.getSelectedProject();
    if (selectedProject?.Oid) {
      this.eventBus.broadcastEvent('navigation:redirectToTab', 'tabProperty', () => {
        //after redirected, trigger assignCalculationModelTemplate
        this.eventBus.broadcastEvent('properties:assignCalculationModelTemplate', selectedProject);
      });
    }
  }
  /**
   * Set search bar visibility
   */
  setSearchBarVisibility() {
    this.searchTabVisible = !this.searchTabVisible;
    this.eventBus.broadcastEvent('searchBarVisibility', this.searchTabVisible, this.searchMode);
  }
  /**
   * Show participants template
   */
  showParicipantsTemplate() {
    this.showParicipantsAssignmentNavigation = !this.showParicipantsAssignmentNavigation;
    this._raciNavigationService.showParticipantsAssignment(this.showParicipantsAssignmentNavigation);
    this.eventBus.broadcastEvent('backClickedTrue');
    this.eventBus.broadcastEvent('showSaveCancelNavigationAction', false);
  }
  /**
   * On save project participants
   */
  onSaveProjectParticipants() {
    this._raciNavigationService.onSaveProjectParticipants();
  }

  /**
   * Info message
   */
  infoMessage() {
    if (!this.showSteps) {
      alert('Please assign properties and participants to the project, before starting the process module');
    } else {
      this._raciService.displayDataLoader(true);
    }
  }

  /**
   * Emit event to close participant assignment
   */
  closeParticipants() {
    this.closeParticipantAssignment = true;
    this._raciNavigationService.closeParticipantsAssignment(true);
  }

  /**
   * Check if project is selected on initialize
   */
  isProjectSelected(): boolean {
    const project = this.appStorage.getSelectedProject();
    if (project) {
      return true;
    }
    return false;
  }

  /**
   * Show the projects export pane
   */
  showProjectsExportPane() {
    this.eventBus.broadcastEvent('showProjectsExportPane');
  }
}
